module.exports = __webpack_public_path__ + "img/disney-logo-dark.b8da9a06.svg";